import React from 'react';
import {OFFERS_TABS, type OffersTab} from '../../model/offersFilters';
import styles from './OffersTabs.module.css';

interface OffersTabsProps {
	value: OffersTab;
	onChange: (value: OffersTab) => void;
}

export function OffersTabs({value, onChange}: OffersTabsProps): React.ReactElement {
	return (
		<div className={styles.tabs} role="tablist" aria-label="Фильтр предложений">
			{OFFERS_TABS.map((tab) => {
				const selected = tab.id === value;

				return (
					<button
						key={tab.id}
						type="button"
						role="tab"
						aria-selected={selected}
						className={selected ? `${styles.tab} ${styles.tabActive}` : styles.tab}
						onClick={() => onChange(tab.id)}
					>
						{tab.label}
					</button>
				);
			})}
		</div>
	);
}
